export default {
      id: "logo-crema-review-usage",
      viewBox: "0 0 180 17",
      url: __webpack_public_path__ + "img/icons.c2f64a3b.svg#logo-crema-review",
      toString: function () {
        return this.url;
      }
    }